import { cva } from 'class-variance-authority';

export const alertVariants = cva('gap-lg p-xl border rounded-md shadow-md', {
  variants: {
    color: {
      brand: 'bg-brand-primary text-brand-tertiary border-brand-secondary',
      success: 'bg-success-primary text-success-primary border-utility-success-300',
      warning: 'bg-warning-primary text-warning-primary border-utility-warning-300',
      error: 'bg-error-primary text-error-primary border-error',
      default: 'bg-workspace text-tertiary border-primary',
      info: 'bg-workspace text-tertiary border-primary',
    },
    direction: {
      row: '',
      col: 'items-start',
    },
  },
});

export const containerVariants = cva('flex flex-1 justify-between', {
  variants: {
    direction: {
      row: 'flex-row items-center',
      col: 'flex-col gap-y-lg',
    },
  },
});

export const infoVariants = cva('flex flex-1', {
  variants: {
    direction: {
      row: 'flex-row gap-x-sm me-lg',
      col: 'flex-col gap-y-xxs',
    },
  },
});
